import { withStyles } from '@material-ui/core';
import HubWidget from './HubWidget';
import styles from './styles';

export default withStyles(styles)(HubWidget)
